import React, { useState,  useEffect } from 'react'
import { Dialog,  Button,  Toast,  List  } from 'antd-mobile'
import './index.css'
import { useNavigate,useLocation } from 'react-router-dom'
import { opt_isKeyPoint, opt_probability, parseQueryString } from '../interface';
// import { Avatar} from 'antd';
import axios from "axios";
// import moment from 'moment';
import { domain, opt_products, opt_type, opt_level, opt_module } from '../interface';

const Detail = () => {
    let navigate = useNavigate()
    let location = useLocation()

    const [pathUrl, setPathUrl] = useState(parseQueryString(window.location.href));
    const [data, setData] = useState([])
    const [processStatus, setProcessStatus] = useState(0)
    const [buttonText, setButtonText] = useState("关闭CASE")
    const [isDisabled, setIsDisabled] = useState(false)

    const titles = {
        title: '标题',
        customerName: '客户名称',
        customerCode: '客户代码',
        customerRelator: '问题反馈客户姓名',
        planTime: '期望解决时间',
        product: '所属产品',
        probability: '商机赢率',
        isKeyPoint: '是否回款卡点',
        module: '系统模块',
        type: '问题类型',
        level: '优先级',
        attachmentUrl: '附件',
        content: '问题描述',
        dingurl: "审批",
        zentaoId: "禅道链接",
        constantname:"研发状态"
    };


    const getDetails = (id) => {
        axios
            .post(domain + "/form/find/form", { id })
            .then((res) => {
                let caseObjs = [];
                console.log(res.data)
                let pr = res.data.data["processStatus"]
                setProcessStatus(res.data.data["processStatus"]);
                if(pr==9){
                    console.log("......")
                    setButtonText("已关闭");
                    setIsDisabled(true);
                }

                for (let k in titles) {
                    let v = res.data.data[k];

                    if (k === "product") {
                        opt_products.forEach((item) => {
                            if (item.value == res.data.data[k]) {
                                v = item.label;
                            }
                        });
                    }
                    if (k === "type") {
                        opt_type.forEach((item) => {
                            if (item.value === res.data.data[k]) {
                                v = item.label;
                            }
                        });
                    }

                    if (k === "level") {
                        opt_level.forEach((item) => {
                            if (item.value === res.data.data[k]) {
                                v = item.label;
                            }
                        });
                    }


                    if (k === "attachmentUrl") {
                        let fileUrls = v.split("||");
                        let sn = 1
                        let newValue = ""
                        fileUrls.forEach((item) => {
                            newValue = newValue + "<a href='" + item + "'>附件文件" + sn + "</a><br/>";
                            sn = sn + 1
                        });
                        v = newValue;
                    }
                    if (k === "dingurl") {
                        v = "<a href='" + v + "'>审批链接</a><br/>";
                    }

                    if (k === "zentaoId") {
                        // "1":"需求"；"2":"Bug"},
                        if (v != null && v != "") {
                            if (res.data.data["type"] == "1") {
                                v = "http://z.meix.com/zentao/www/index.php?m=story&f=view&id=" + v + "&t=html";
                            }
                            if (res.data.data["type"] == "2") {
                                v = "http://z.meix.com/zentao/www/index.php?m=bug&f=view&id=" + v + "&t=html";
                            }
                            // v="<a href='"+v+"'>禅道链接</a><br/>";
                        }
                    }

                    if (k === "module") {
                        opt_module.forEach((item) => {
                            if (item.value === res.data.data[k]) {
                                v = item.label;
                            }
                        });
                    }

                    // if (k === "probability") {
                    //     opt_probability.forEach((item) => {
                    //         if (item.value === res.data.data[k]) {
                    //             v = item.label;
                    //         }
                    //     });
                    // }


                    // if (k === "isKeyPoint") {
                    //     opt_isKeyPoint.forEach((item) => {
                    //         if (item.value === res.data.data[k]) {
                    //             v = item.label;
                    //         }
                    //     });
                    // }                    

                    caseObjs.push({ value: v, key: titles[k] })
                }

                let logs = res.data.data["logs"];
                let logstr = "";
                for (let i = 0; i < logs.length; i++) {
                    logstr = logstr + "【" + logs[i]["sdate"] + "】" + logs[i]["realname"] + "：" + logs[i]["action"] + " " + logs[i]["extra"]+ " " + logs[i]["comment"] + "<br/>"
                }
                caseObjs.push({ value: logstr, key: "禅道日志" })
                // console.log(caseObjs)
                setData(caseObjs);
            })
            .catch((error) => {
                console.log(error)
            });
    }

    useEffect(() => {
        // setData(getDetails(pathUrl.id))
        const { state } = location
        getDetails(state.id)
    }, [pathUrl])


    // const back = () => {
    //     window.history.back(-1)
    // }

    const closeCase = () => {
        const { state } = location
        axios
            .post(domain + "/form/case/close", { "processid":state.id })
            .then((res) => {
                // console.log(res);
                if (res.status == 200 && res.data) {
                    if (res.data.code == 200) {
                        // console.log("关闭case")
                        setButtonText("已关闭");
                        setIsDisabled(true);
                    } else {
                        Toast.show({
                            content: res.data.message,
                        })
                    }
                }
            })
            .catch((error) => {
                console.log(error)
            });
    }

    return (
        <div className='page'>
            <List header='问题详情' mode="card">
            {data.map(item => (
                <List.Item
                description={<div dangerouslySetInnerHTML={{ __html: item.value}}></div>}
                >
                {item.key} 
                </List.Item>
            ))}
            </List>
            <Button block disabled={isDisabled} color='primary' size='large' onClick={async () => {
                    const result = await Dialog.confirm({
                        content: '是否关闭CASE？',
                    })
                    if (result) {
                        closeCase();
                    }
                }
            }>
                {buttonText}
            </Button>

        </div>
    )
}
export default Detail
